import { PlainMessage } from "@bufbuild/protobuf";
import { createSchema, ZodOutputFor } from "../zod-utils";
import { LocationMetadata as ProtoLocationMetadata } from "@opstel/gen/knop/ui/v1/api/location_list_pb";
import { z } from "zod/v3";

export interface LocationMetadata {
  code: string;
  name: string;
}

export const locationmetadataSchema = createSchema<
  LocationMetadata,
  PlainMessage<ProtoLocationMetadata>
>({
  code: z.string().min(1, "Location should have a code"),
  name: z.string().min(1, "Location should have a name"),
}) satisfies ZodOutputFor<LocationMetadata>;
